// Formatting shared by the Trasferte section.
//
// The escape sequences are defined here, inside string literals, where
// JavaScript decodes them. Written into JSX text instead they print
// character for character.
export const DASH = "\u2014";
export const EN_DASH = "\u2013";
export const DOT = "\u00b7";

// Dates and numbers follow the language chosen in Core rather than the one the
// operating system happens to be set to.
export function localeFor(language) {
  return language === "it" ? "it-IT" : "en-US";
}

export function formatDate(iso, language) {
  try {
    return new Date(iso).toLocaleDateString(localeFor(language), {
      day: "2-digit", month: "short", year: "numeric",
    });
  } catch (e) {
    return iso || "";
  }
}

/** "2026-08-20" rendered without going through UTC, which would move the day
 *  across the date line for anybody west of Greenwich. */
export function formatDay(value, language) {
  if (!value) return "";
  const [y, m, d] = String(value).split("-").map(Number);
  if (!y || !m || !d) return value;
  return new Date(y, m - 1, d).toLocaleDateString(localeFor(language), {
    day: "2-digit", month: "short", year: "numeric",
  });
}

/**
 * When a trip happened, as a person would say it.
 *
 * One date on its own. Two inside the same month with the month and the year
 * said once. Nothing at all when nobody recorded the dates, rather than
 * falling back to the day the record was typed in: that is not a fact about
 * the trip.
 */
export function tripDates(trip, language) {
  const from = trip.visited_from;
  const to = trip.visited_to;
  if (!from) return "";
  if (!to || to === from) return formatDay(from, language);

  const [fromYear, fromMonth, fromDay] = from.split("-");
  const [toYear, toMonth] = to.split("-");
  if (fromYear === toYear && fromMonth === toMonth) {
    return `${Number(fromDay)} ${EN_DASH} ${formatDay(to, language)}`;
  }
  return `${formatDay(from, language)} ${EN_DASH} ${formatDay(to, language)}`;
}

// t() returns the key itself when there is no translation for it, which is
// never falsy, so `t(key) || fallback` cannot reach its fallback.
export function translateOr(t, key, fallback) {
  const value = t(key);
  return value === key ? fallback : value;
}
